import { type ReactNode, useLayoutEffect, useRef, useState } from 'react'
import * as m from '~/paraglide/messages'
import { cn } from '~/shared/lib/utils'

export function ClampedContent({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  const ref = useRef<HTMLDivElement>(null)
  const [expanded, setExpanded] = useState(false)
  const [overflowing, setOverflowing] = useState(false)

  useLayoutEffect(() => {
    const node = ref.current
    if (!node || expanded) return
    const measure = () => setOverflowing(node.scrollHeight > node.clientHeight + 1)
    measure()
    const observer = new ResizeObserver(measure)
    observer.observe(node)
    return () => observer.disconnect()
  }, [expanded])

  return (
    <div>
      <div ref={ref} className={cn(!expanded && 'line-clamp-3', className)}>
        {children}
      </div>
      {overflowing || expanded ? (
        <button
          type="button"
          aria-expanded={expanded}
          onClick={() => setExpanded((value) => !value)}
          className="mt-1 font-medium text-brand-subtle-foreground text-sm hover:underline"
        >
          {expanded ? m.showLess() : m.placeDetailShowMore()}
        </button>
      ) : null}
    </div>
  )
}
